module.exports = __webpack_public_path__ + "static/img/6.71318670.png";